export const environment = {
  production: true,
  apiUrl: 'https://puntodefuga-f9befddyhzgxdrda.canadacentral-01.azurewebsites.net', // Cambiar por la URL de producción cuando despliegues
  mercadoPagoPublicKey: 'TU_PUBLIC_KEY_PRODUCCION_AQUI', // Reemplazar con tu Public Key de producción de Mercado Pago
  msalConfig: {
    auth: {
      clientId: '57968bc1-d3ff-4d8b-996c-342ee5f77d68',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: window.location.origin
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false
    }
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me'
  }
};
